import { jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import style from './image.module.scss.js';

const Image = props => {
  const {
    item
  } = props;
  const classNames = getClassNames(style.root, 'llm__image', {
    [`llm__image--${item.type}`]: !!item.type
  });
  return jsx("div", {
    className: classNames,
    children: item.url ? jsx("div", {
      className: "llm__row",
      children: jsx("div", {
        className: "llm__col --end-xs-12 --xs-10 --sm-9 --md-8 --lg-7 --xl-6",
        children: jsx("img", {
          className: style.image,
          src: item.url,
          alt: ""
        })
      })
    }) : jsx("pre", {
      className: classNames,
      children: JSON.stringify(item, null, 2)
    })
  });
};

export { Image };
//# sourceMappingURL=image.js.map
